import { render, staticRenderFns } from "./GovHero.vue?vue&type=template&id=9b2f5e22&scoped=true"
import script from "./GovHero.vue?vue&type=script&lang=js"
export * from "./GovHero.vue?vue&type=script&lang=js"
import style0 from "./GovHero.vue?vue&type=style&index=0&id=9b2f5e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2f5e22",
  null
  
)

export default component.exports